import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatCrypto } from '../../utils/numbers';
import { Box, Text } from 'components/Wrapped';
import { withNamespaces } from 'react-i18next';

const CreateOrderFee = ({ currencySettings, tradingPair, total, side, t }) => {
  const singleCurrencySettings = currencySettings[tradingPair.baseCurrency];

  const feePercent = singleCurrencySettings[`${side.toLowerCase()}ServiceCharge`] / 100;
  const fee = total * feePercent;

  return (
    <Box pad="none" direction="row" align="center" justify="between">
      <Text color="#B4B6B7" size="11px" weight={500} style={{ lineHeight: '13px' }}>
        {/* {t('forms.estimatedFee')} */}
        Комиссия
      </Text>
      <Text color="white" size="12px" weight={500} style={{ lineHeight: '15px' }}>
        {formatCrypto(fee, false, singleCurrencySettings.decimalPrecision)} {tradingPair.quoteCurrency}
      </Text>
    </Box>
  );
};

CreateOrderFee.propTypes = {
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

CreateOrderFee.defaultProps = {
  total: 0,
};

const mapStateToProps = ({ exchangeSettings }) => ({
  currencySettings: exchangeSettings.currencySettings,
});

export default withNamespaces()(connect(mapStateToProps)(CreateOrderFee));
